import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const included = ['6 Core Volumes', '5 Bonuses', 'Instant Digital Access'];
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-powder px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-88" data-mp="53o7qw3dksen">
      <div className="mx-auto max-w-4xl" data-id="element-89" data-mp="iutba99v64u9">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold-dark" data-id="element-90" data-mp="ixnvq0svnpno">
          Ready When You Are
        </p>
        <h2 id="final-heading" className="mx-auto mt-4 font-display text-[2.6rem] font-bold leading-[1.04] text-brand-charcoal sm:text-[3.4rem]" data-id="element-91" data-mp="su0omwgllzhd">
          Your Next Barbering Class Doesn't Have to <Accent data-id="element-92" data-mp="2ulwy80j7gz9i">Start From Scratch.</Accent>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-93" data-mp="2pm0wy91w7lxn">
          Get the teaching structure, student resources and practical tools you need — all in one
          organized system.
        </p>

        <img src={MOCKUP_URL} alt="The complete Barber Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(20, 40, 59, 0.22))'
      }} data-id="element-94" data-mp="2vhdxu0notw1b" />

        <CtaBlock label="Start Teaching Smarter Today" className="mt-10" data-id="element-95" data-mp="3e6klm23c9dtz" />

        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-96" data-mp="3j6gmvtknir5u">
          {included.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/70" data-id="element-97" data-mp="3n8brb6xvpknu">
              <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-98" data-mp="1oth3rqh2bett" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-xl font-display text-[1.3rem] italic leading-snug text-brand-charcoal/80" data-id="element-99" data-mp="2w4ojuyyxm12u">
          Created for barber educators who are ready to spend less time preparing — and more time teaching.
        </p>
      </div>
    </section>;
}